import { Avatar } from '@chakra-ui/react';
import { useNavigate } from 'react-router-dom';
import { setChatInfo } from '../../redux-toolkit/reducers/chatSlice';
import { useDispatch } from 'react-redux';

const RandomFounderCard = ({ founder }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const viewDetails = () => {
    navigate(
      `/view-user?userid=${founder?.id}&usertype=1&cid=${founder?.company?.id || founder?.companies?.[0]?.id}`,
    );
  };

  const onConnect = (e) => {
    e.stopPropagation();
    dispatch(setChatInfo(founder));
    navigate('../connections');
  };

  return (
    <div
      onClick={viewDetails}
      className="w-full border border-gray-200 rounded-xl bg-white p-4 shadow-sm cursor-pointer"
    >
      <div className="w-fit text-blue-700 font-semibold mb-2 text-base underline cursor-pointer">
        Featured Founder
      </div>
      <div className="relative mb-4">
        <div className="h-28 sm:h-25 w-full">
          <img
            src={
              founder?.cover_image ||
              'https://images.unsplash.com/photo-1557683316-973673baf926?auto=format&fit=crop&w=600&q=80'
            }
            alt="Banner"
            className="w-full h-full object-cover opacity-70 rounded-sm"
          />
          <div className="absolute top-4 sm:top-2 flex flex-col justify-center pl-4 sm:pl-6">
            {/* <span className="text-white font-bold text-lg sm:text-2xl leading-tight drop-shadow">
              develop your <br /> custom software?
            </span> */}
          </div>
        </div>
        <Avatar
          name={`${founder?.first_name} ${founder?.last_name}`}
          src={founder?.profile_image}
          w={{ base: '16', sm: '20' }}
          h={{ base: '16', sm: '20' }}
          position="absolute"
          left={{ base: '4', sm: '6' }}
          bottom="-8"
          border="4px solid transparent"
          boxShadow="lg"
          objectFit="cover"
          zIndex="1"
          cursor="pointer"
          onClick={viewDetails}
        />
      </div>
      <div className="mb-2 mt-8">
        <div className="font-semibold text-gray-900">
          {`${founder?.first_name} ${founder?.last_name}`}
        </div>
        {/* <div className="text-xs text-gray-600">
          {founder?.title || 'CEO &amp; Co-Founder at Credora Investment'}{' '}
          <br />
        </div> */}
      </div>

      {founder?.bio && (
        <div className="text-sm text-gray-700 mb-4">{founder?.bio}</div>
      )}
      <button className="bg-blue-100 text-blue-700 font-semibold px-4 py-2 rounded-lg text-sm hover:bg-blue-200 transition">
        <span onClick={onConnect} className="font-medium">
          Connect
        </span>
      </button>
    </div>
  );
};

export default RandomFounderCard;
